<div class="wrapper">
  <span class="title">What's New in Version {{ currentVersion }}</span>
  <div class="content">
    <ng-container *ngFor="let note of releaseNotes">
      <h3 *ngIf="note.type === 'heading'" class="note-heading">{{ note.text }}</h3>
      <p *ngIf="note.type === 'paragraph'" class="note-paragraph">{{ note.text }}</p>
      <p *ngIf="note.type === 'bullet'" class="note-bullet">{{ note.text }}</p>
    </ng-container>
  </div>
  <ion-button class="got-it-button" (click)="markAsSeen()">Got it!</ion-button>
</div> 